import { render, staticRenderFns } from "./focus.vue?vue&type=template&id=07f9ab3a&scoped=true&"
import script from "./focus.vue?vue&type=script&lang=js&"
export * from "./focus.vue?vue&type=script&lang=js&"
import style0 from "./focus.vue?vue&type=style&index=0&id=07f9ab3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f9ab3a",
  null
  
)

export default component.exports